import React from 'react';
import {connect} from "react-redux";
import PaginationButton from "./common/PaginationButton";

export const PREV_CONTENT = 'GOT_PREV_CONTENT';
export const NEXT_CONTENT = 'GOT_NEXT_CONTENT';

const Pagination=({path, type, handleData, lastPage, filters, data, dispatch})=>{
    return (<div className='pagination-panel'>
                <div className='pagination-nav'>
                    <PaginationButton newPage={filters.curPages[type] - 1} paginationEventType={PREV_CONTENT} path={path} handleData={handleData} type={type} className={filters.curPages[type] == 1 ? 'hidden-btn' : 'icon-btn prev-btn'}/>
                    <div className='page-number'>{filters.curPages[type]}</div>
                    <PaginationButton newPage={filters.curPages[type] + 1} paginationEventType={NEXT_CONTENT} path={path} handleData={handleData} type={type} className={lastPage ? 'hidden-btn' : 'icon-btn next-btn'}/>
                </div>
                <div>Максимальное число записей на страницу: {filters.limit}</div>
             </div>);
};

const mapStateToProps=(state)=>({filters:state.filters, data: state.data});
const ConnectedPagination=connect(mapStateToProps)(Pagination);
export default ConnectedPagination;